export interface ISerologyDataValidation {
    serologyMaxDaysBeforeSurgery: boolean,
    serologyShipToId: boolean
}